/**
 * Host confirmation before a file is opened in a plugin the user did not pick
 * for it (ADR-030). Opening grants the plugin read access to that one file,
 * so when the handoff came from the assistant or from another app — not from
 * the user's own "Open in…" click — the host asks first.
 */
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export interface HandoffConfirmSheetProps {
  appName: string;
  fileName: string;
  onResolve: (allowed: boolean) => void;
}

export function HandoffConfirmSheet({ appName, fileName, onResolve }: HandoffConfirmSheetProps) {
  return (
    <AlertDialog open onOpenChange={(open) => !open && onResolve(false)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Open “{fileName}” in {appName}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            {appName} will be able to read this file. It opens a copy — your file is not changed.
            You can remove this access any time in Vault → App Access.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => onResolve(false)}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={() => onResolve(true)}>Open</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
